import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import { close } from '#utilities/js/lightboxes/seamless.js'
import click from '@mailobj-browser/front/js/events/types/click.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import capture from '@mailobj-browser/front/js/events/options/capture.js'
import once from '@mailobj-browser/front/js/events/options/once.js'

const onClick = object(listener, {
  type: click,
  capture,
  once,
  passive,
  task: close
})

export default button => {
  onClick.listen(button)
}